import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from '../abstractRequest';
import {FormBuilderEnums} from '../../../../../../../infra/formBuilder/formBuilder.service';

@Injectable()
export class AlmaResourceSharing extends AbstractRequest{


    constructor() {
        super();
        this.sectionsMap = {'owner':1,'type':2,'book':3,'article':4,'delivery':5};
        this.formFields = [
            {
                key: 'citationType',
                name: 'citationType',
                label: 'almaResourceSharing.citationType',
                value: 'book',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                existingPath: 'dummyPath',
                valuePath: 'citationType',
                uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
                populator:  {
                    params:     {
                        defaultValuePath: 'citationType'
                    }
                },
                options:[
                    {
                        label:'almaResourceSharing.book',
                        value:'BK'
                    },
                    {
                        label:'almaResourceSharing.article',
                        value:'CR'
                    }
                ],
                events: {
                    onClick: this.onClick.bind(this),
                    params: []
                }

            },
            {
                key: 'title',
                name: 'title',
                label: 'almaResourceSharing.title',
                existingPath: 'dummyPath',
                valuePath: 'title',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'BK'},
                maxlength:4000
            },
            {
                key: 'articleTitle',
                name: 'articleTitle',
                label: 'almaResourceSharing.articleTitle',
                existingPath: 'dummyPath',
                valuePath: 'articleTitle',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'CR'},
                maxlength:4000
            },
            {
                key: 'journalTitle',
                name: 'journalTitle',
                label: 'almaResourceSharing.journalTitle',
                existingPath: 'dummyPath',
                valuePath: 'journalTitle',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'CR'},
                maxlength:4000
            },
            {
                key: 'author',
                name: 'author',
                label: 'almaResourceSharing.authors',
                existingPath: 'dummyPath',
                valuePath: 'author',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'authorInitials',
                name: 'authorInitials',
                label: 'almaResourceSharing.authInit',
                existingPath: 'dummyPath',
                valuePath: 'authorInitials',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'issue',
                name: 'issue',
                label: 'almaResourceSharing.issue',
                existingPath: 'dummyPath',
                valuePath: 'issue',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'CR'}
            },
             {
                key: 'specificEdition',
                name: 'specificEdition',
                label: '',
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                populator:  {
                    func: this.hardCodedPopulator.bind(this)
                },
                options:[
                    {
                        label:'almaResourceSharing.specificEdition',
                        value:'Y'
                    }
                ],
                dependOn: {key : 'citationType', value: 'BK'}
            },
           {
                key: 'edition',
                name: 'edition',
                label: 'almaResourceSharing.edition',
                existingPath: 'dummyPath',
                valuePath: 'edition',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'BK'},
                maxlength:4000
            },
            {
                key: 'isbn',
                name: 'isbn',
                label: 'almaResourceSharing.isbn',
                existingPath: 'dummyPath',
                valuePath: 'isbn',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'BK'},
                maxlength:4000
            },
            {
                key: 'issn',
                name: 'issn',
                label: 'almaResourceSharing.issn',
                existingPath: 'dummyPath',
                valuePath: 'issn',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'CR'},
                maxlength:4000
            },
            {
                key: 'lccn',
                name: 'lccn',
                label: 'almaResourceSharing.lccNumber',
                existingPath: 'dummyPath',
                valuePath: 'lccn',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'oclcNumber',
                name: 'oclcNumber',
                label: 'almaResourceSharing.oclcNumber',
                existingPath: 'dummyPath',
                valuePath: 'oclcNumber',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'doi',
                name: 'doi',
                label: 'almaResourceSharing.doi',
                existingPath: 'dummyPath',
                valuePath: 'doi',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'CR'},
                maxlength:4000
            },
            {
                key: 'pmid',
                name: 'pmid',
                label: 'almaResourceSharing.pmid',
                existingPath: 'dummyPath',
                valuePath: 'pmid',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'CR'},
                maxlength:4000
            },

            {
                key: 'publisher',
                name: 'publisher',
                label: 'almaResourceSharing.publisher',
                existingPath: 'dummyPath',
                valuePath: 'publisher',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'publicationDate',
                name: 'publicationDate',
                label: 'almaResourceSharing.year',
                existingPath: 'dummyPath',
                valuePath: 'publicationDate',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'placeOfPublication',
                name: 'placeOfPublication',
                label: 'almaResourceSharing.placeOfPublication',
                existingPath: 'dummyPath',
                valuePath: 'placeOfPublication',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'additionalAuthor',
                name: 'additionalAuthor',
                label: 'almaResourceSharing.additionalAuthor',
                existingPath: 'dummyPath',
                valuePath: 'additionalAuthor',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'volume',
                name: 'volume',
                label: 'almaResourceSharing.volume',
                existingPath: 'dummyPath',
                valuePath: 'volume',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'BK'},
                maxlength:4000
            },{
                key: 'journalVolume',
                name: 'journalVolume',
                label: 'almaResourceSharing.journalVolume',
                existingPath: 'dummyPath',
                valuePath: 'journalVolume',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'CR'},
                maxlength:4000
            },
            {
                key: 'part',
                name: 'part',
                label: 'almaResourceSharing.part',
                existingPath: 'dummyPath',
                valuePath: 'part',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'BK'},
                maxlength:4000
            },
            {
                key: 'chapter',
                name: 'chapter',
                label: 'almaResourceSharing.chapter',
                existingPath: 'dummyPath',
                valuePath: 'chapter',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'source',
                name: 'source',
                label: 'almaResourceSharing.source',
                existingPath: 'dummyPath',
                valuePath: 'source',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'seriesTitleNumber',
                name: 'seriesTitleNumber',
                label: 'almaResourceSharing.seriesTitleNumber',
                existingPath: 'dummyPath',
                valuePath: 'seriesTitleNumber',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'pagesToPhotocopy',
                name: 'pagesToPhotocopy',
                label: 'almaResourceSharing.pages',
                existingPath: 'dummyPath',
                valuePath: 'pagesToPhotocopy',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:4000
            },
            {
                key: 'startPage',
                name: 'startPage',
                label: 'almaResourceSharing.startPage',
                existingPath: 'dummyPath',
                valuePath: 'startPage',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'CR'},
                maxlength:4000,
                inputType:'number',
                validPattern: '[1-9]\\d*'
            },
            {
                key: 'endPage',
                name: 'endPage',
                label: 'almaResourceSharing.endPage',
                existingPath: 'dummyPath',
                valuePath: 'endPage',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'CR'},
                maxlength:4000,
                inputType:'number',
                validPattern: '[1-9]\\d*'
            },
            {
                key: 'maximumFee',
                name: 'maximumFee',
                label: 'almaResourceSharing.maximumFee',
                existingPath: 'dummyPath',
                valuePath: 'maximumFee',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:19,
                inputType:'number'
            },{
                key: 'format',
                name: 'format',
                label: 'almaResourceSharing.format',
                path: 'formatOptions',
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
                populator:  {
                func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        defaultValuePath: 'format'
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }

            },{
                key: 'alternativeLocationAddress',
                name: 'alternativeLocationAddress',
                label: 'almaResourceSharing.deliveryLocationToAlternativeAddress',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                path: 'alternativeLocationAddress',
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                    },
                   deleteFromFormDataIfHidden: 'true'
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },{
                key: 'alternativeLocationEmail',
                name: 'alternativeLocationEmail',
                label: 'almaResourceSharing.deliveryLocationToAlternativeEmail',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                path: 'alternativeLocationEmail',
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        defaultValuePath:'alternativeLocationEmailDefault'
                    },
                    deleteFromFormDataIfHidden:'false'
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },{
                key: 'email',
                name: 'email',
                label: 'almaResourceSharing.deliveryAlternative.email',
                existingPath: 'dummyPath',
                valuePath: 'email',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'alternativeLocationEmail', value: 'alternativeEmail',showIfFieldByKeyDoesntExist:'false'},
                maxlength:255
            },{
                key: 'line1',
                name: 'line1',
                label: 'almaResourceSharing.deliveryAlternative.line1',
                existingPath: 'dummyPath',
                valuePath: 'line1',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'alternativeLocationAddress', value: 'alternativeAddress',showIfFieldByKeyDoesntExist:'false'},
                maxlength:255
            },{
                key: 'line2',
                name: 'line2',
                label: 'almaResourceSharing.deliveryAlternative.line2',
                existingPath: 'dummyPath',
                valuePath: 'line2',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'alternativeLocationAddress', value: 'alternativeAddress',showIfFieldByKeyDoesntExist:'false'},
                maxlength:255
            },{
                key: 'line3',
                name: 'line3',
                label: 'almaResourceSharing.deliveryAlternative.line3',
                existingPath: 'dummyPath',
                valuePath: 'line3',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'alternativeLocationAddress', value: 'alternativeAddress',showIfFieldByKeyDoesntExist:'false'},
                maxlength:255
            },{
                key: 'line4',
                name: 'line4',
                label: 'almaResourceSharing.deliveryAlternative.line4',
                existingPath: 'dummyPath',
                valuePath: 'line4',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'alternativeLocationAddress', value: 'alternativeAddress',showIfFieldByKeyDoesntExist:'false'},
                maxlength:255
            },{
                key: 'requestedMedia',
                name: 'requestedMedia',
                label: 'almaResourceSharing.requestedMedia',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                path: 'requestedMedia',
                populator:  {
                    func: this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        defaultValuePath:'requestedMediaDefault'
                    }
                }
            },{
                key: 'owner',
                name: 'owner',
                path: 'groups-list-map/owner',
                label: 'almaResourceSharing.owner',
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        byCategory: 'category',
                        filters :['pickupLocation'],
                        singleValueBehaviour: FormBuilderEnums.UI_TYPE.HIDDEN,
                        defaultValuePath:'owner'
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },{
                key: 'pickupLocation',
                name: 'pickupLocation',
                path: 'groups-list-map/pickupLocation',
                label: 'almaResourceSharing.pickupLibrary',
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        filters :['owner'],
                        defaultValuePath:'pickupLocationDefault'
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
                dependOn: {key : 'citationType', value: ['BK','CR']}
            },{
                key: 'preferredLocalPickupLocation',
                name: 'preferredLocalPickupLocation',
                path: 'groups-list-map/preferredLocalPickupLocation',
                label: 'almaResourceSharing.preferredLocalPickupLocation',
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                         filters :['owner'],
                        defaultValuePath:'pickupLocationDefault'
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
                dependOn: {key : 'citationType', value: ['BK','CR']}
            },{
                key: 'preferredPickupInstitution',
                name: 'preferredPickupInstitution',
                path: 'ful-net-rs-groups-list-map/preferredPickupInstitution',
                label: 'almaResourceSharing.preferredPickupInstitution',
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        filters :['preferredPickupLocation'],
                        defaultValuePath:'preferredPickupInstitutionDefault'
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
                dependOn: {key : 'citationType', value: ['BK','CR']}
            },{
                key: 'preferredPickupLocation',
                name: 'preferredPickupLocation',
                path: 'ful-net-rs-groups-list-map/preferredPickupLocation',
                label: 'almaResourceSharing.preferredPickupLocation',
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN,
                origUiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        filters :['preferredPickupInstitution'],
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
                dependOn: {method: this.otherInstitutionChosen.bind(this)}
            }, {
                key: 'allowOtherLibrary',
                name: 'allowOtherLibrary',
                value: 'true',
                label: '',
                path: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN,
                origUiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                options:[
                    {
                        label:'almaResourceSharing.allowOtherLibrary',
                        value:'true'
                    }
                ],
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
                 dependOn: {method: this.otherInstitutionChosen.bind(this)}

            },{
                key: 'notNeedAfter',
                name: 'notNeedAfter',
                label: 'almaRequest.notNeedAfter',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
                uiType: FormBuilderEnums.UI_TYPE.DATE,
                minDate: 'now',
                populator:  {
                    params:     {
                        allow       : FormBuilderEnums.FUTURE_DATES
                    }
                }
            },
            {
                key: 'comment',
                name: 'comment',
                label: 'almaResourceSharing.comment',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                maxlength:1000
            },
             {
                key: 'language',
                name: 'language',
                label: 'almaResourceSharing.language',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                path: 'language',
                populator:  {
                    func: this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value'
                    }
                }
            },
           {
                key: 'levelOfService',
                name: 'levelOfService',
                label: 'almaResourceSharing.levelOfService',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                path: 'levelOfService',
                populator:  {
                    func: this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        defaultValuePath:'levelOfServiceDefault'
                    }
                }
            },
            {
                key: 'physicalServicesResultId',
                name: 'physicalServicesResultId',
                label: 'almaDigitization.physicalServicesResultId',
                mandatory: true,
                valuePath: 'physicalServicesResultId',
                existingPath: 'physicalServicesResultId',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            }

        ];
    }

    protected createOption(field, data) {
        let value = data[field.populator.params.key];
        let start = data[field.populator.params.value].slotstart.hour;
        let end = data[field.populator.params.value].slotend.hour;
        let startHour = moment(start, 'HHmm').format('HH:mm');
        let endHour = moment(end, 'HHmm').format('HH:mm');
        let label = startHour +' - '+endHour;
        let option = {label:label ,value:value};
        if ((end !== '0000') && parseInt(start) > parseInt(end)) {
           option.info = 'Information';
        }
        console.log('value ' +value);
        return option;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/alma/almaResourceSharing.ts